import {Route} from "vue-router";
import WesleaDevFixture from "@/modules/perRoad/views/components/inspection/WesleaDevFixture.vue";
import PavementStructureLayers from "@/modules/structure/views/1 - Layers.vue";
import PavementStructureScenarioContainer from "@/modules/structure/views/PavementStructureScenarioContainer.vue";
import PavementStructureLoading from "@/modules/structure/views/2 - Loading.vue";
import PavementStructureResponseLocations from "@/modules/structure/views/3 - Response Locations.vue";
import PavementStructureTransferFunctions from "@/modules/structure/views/4 - Transfer Functions.vue";
import PavementStructureResults from "@/modules/structure/views/5 - Results.vue";

export const structurePages = [
  {link: "1", text: "Layers"},
  {link: "2", text: "Loads"},
  {link: "3", text: "Response Locations"},
  {link: "4", text: "Transfer Functions"},
  {link: "5", text: "Results"},
];

export const structureRoutes = {
  path: "/projects/structure/:pxId",
  name: "structure",
  redirect: "/projects/structure/:pxId/1",
  component: PavementStructureScenarioContainer,
  props: (route: Route) => ({
    id: route.params.pxId,
    pages: structurePages,
  }),
  children: [
    {
      path: "1",
      component: PavementStructureLayers,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 1}),
    },
    {
      path: "2",
      component: PavementStructureLoading,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 2}),
    },
    {
      path: "3",
      component: PavementStructureResponseLocations,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 3}),
    },
    {
      path: "4",
      component: PavementStructureTransferFunctions,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 4}),
    },
    {
      path: "5",
      component: PavementStructureResults,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 5}),
    },
    {
      path: "test",
      component: WesleaDevFixture,
      props: (route: Route) => ({pxDesignId: route.params.pxDesignId, page: 6}),
    },
  ],
};
